export default __webpack_public_path__ + "43d5be7cc48f03f06b7ab7989492a7ca.svg";